<template>
  <div>
    <v-tabs
        v-model="currentTab"
        :vertical="showTabsVeritcaly"
        :grow="iconOnly"
        centered
        show-arrows
    >
    <v-tab>
      <v-icon :left="!iconOnly">mdi-robot-vacuum</v-icon>
      <span v-if="!iconOnly">Schnuffel</span>
    </v-tab>
    <v-tab>
      <v-icon :left="!iconOnly">mdi-home-outline</v-icon>
      <span v-if="!iconOnly">Räume</span>
    </v-tab>
    <v-tab>
      <v-icon :left="!iconOnly">mdi-lamps-outline</v-icon>
      <span v-if="!iconOnly">Geräte</span>
    </v-tab>
    <v-tab>
      <v-icon :left="!iconOnly">mdi-flash</v-icon>
      <span v-if="!iconOnly">Strom</span>
    </v-tab>
    <v-tab>
      <v-icon :left="!iconOnly">mdi-gesture-tap</v-icon>
      <span v-if="!iconOnly">Routinen</span>
    </v-tab>
    <v-tab>
      <v-icon :left="!iconOnly">mdi-finance</v-icon>
      <span v-if="!iconOnly">Finanzen</span>
    </v-tab>
    <v-tab>
      <v-icon :left="!iconOnly">mdi-helicopter</v-icon>
      <span v-if="!iconOnly">Flugverkehr</span>
    </v-tab>
    <v-tab-item>
      <Vacuum />
    </v-tab-item>
    <v-tab-item>
      <RoomView />
    </v-tab-item>
    <v-tab-item>
      <DeviceView />
    </v-tab-item>
    <v-tab-item>
      <PowerView />
    </v-tab-item>
    <v-tab-item>
      <RoutineView />
    </v-tab-item>
    <v-tab-item>
      <FinanzenView />
    </v-tab-item>
    <v-tab-item>
      <AdsbMap />
    </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>

import RoomView from "../components/SmartHaus/RoomView";
import DeviceView from "../components/SmartHaus/DeviceView";
import PowerView from "../components/SmartHaus/PowerView";
import RoutineView from "../components/SmartHaus/RoutineView";
import Vacuum from "../components/Vacuum/Vacuum";
import FinanzenView from "../components/SmartHaus/FinanzenView";
import AdsbMap from "../components/Vacuum/AdsbMap";
export default {
  name: "SmartHaus",
  components: {DeviceView, RoomView, PowerView, RoutineView, Vacuum, FinanzenView, AdsbMap},
  data: () => ({
    editMode: false,
    currentTab: 0,
    colors: ["#1F7087","#952175","#958921","#952121", "#579521","#954a21"],
  }),
  computed: {
    showTabsVeritcaly(){
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return false
        case 'sm': return false
        case 'md': return false
        case 'lg': return true
        case 'xl': return true
      }
      return true
    },
    iconOnly() {
      return this.$vuetify.breakpoint.xsOnly
    },
  },
}
</script>

<style scoped>

</style>
